var _linearGradient, _path, _path2, _linearGradient2, _path3, _path4, _linearGradient3, _path5, _linearGradient4, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Connected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "RMkrc95yKh8yGOzJC_U2Aa",
    x1: 15.098,
    x2: 5.869,
    y1: 15.724,
    y2: 6.339,
    gradientTransform: "matrix(1.0041 -.0041 .0041 -1.0041 -.67 48.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    stopColor: "#c9cdcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#e1e2e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#e4e4e6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#RMkrc95yKh8yGOzJC_U2Aa)",
    d: "M4.879,42.414L4.879,42.414c0.781,0.781,2.047,0.781,2.828,0l13.111-13.111l-2.828-2.828 L4.879,39.586C4.098,40.367,4.098,41.633,4.879,42.414z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a1aab3",
    d: "M14.827,38.869l-5.696-5.696c-1.071-1.071-1.445-2.656-0.966-4.093l0,0 c0.416-1.248,1.117-2.382,2.047-3.312l4.95-4.95l12.021,12.021l-4.95,4.95c-0.93,0.93-2.064,1.631-3.312,2.047l0,0 C17.483,40.314,15.899,39.94,14.827,38.869z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "RMkrc95yKh8yGOzJC_U2Ab",
    x1: 33.896,
    x2: 42.887,
    y1: 33.039,
    y2: 42.242,
    gradientTransform: "matrix(1.0041 -.0041 .0041 -1.0041 -.74 48.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    stopColor: "#c9cdcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#e1e2e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#e4e4e6"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#RMkrc95yKh8yGOzJC_U2Ab)",
    d: "M43.121,5.586L43.121,5.586c-0.781-0.781-2.047-0.781-2.828,0L27.182,18.697l2.828,2.828 L43.121,8.414C43.902,7.633,43.902,6.367,43.121,5.586z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#a1aab3",
    d: "M33.173,9.131l5.696,5.696c1.071,1.071,1.445,2.656,0.966,4.093l0,0 c-0.416,1.248-1.117,2.382-2.047,3.312l-4.95,4.95l-12.02-12.021l4.95-4.95c0.93-0.93,2.064-1.631,3.312-2.047l0,0 C30.517,7.686,32.101,8.06,33.173,9.131z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "RMkrc95yKh8yGOzJC_U2Ac",
    x1: -720.552,
    x2: -720.552,
    y1: 504.759,
    y2: 512.881,
    gradientTransform: "rotate(-134.998 -241.45 -398.48) scale(1.0102 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8795a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#78848f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d7882"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#RMkrc95yKh8yGOzJC_U2Ac)",
    d: "M21.102,14.031L33.97,26.899c0.589,0.589,0.589,1.543,0,2.132l-1.403,1.403 c-0.589,0.589-1.543,0.589-2.132,0L17.566,17.566c-0.589-0.589-0.589-1.543,0-2.132l1.403-1.403 C19.558,13.442,20.513,13.442,21.102,14.031z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "RMkrc95yKh8yGOzJC_U2Ad",
    x1: -720.552,
    x2: -720.552,
    y1: 515.168,
    y2: 506.764,
    gradientTransform: "rotate(-134.998 -241.45 -398.48) scale(1.0102 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8795a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#6d7882"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#RMkrc95yKh8yGOzJC_U2Ad)",
    d: "M26.898,33.969L14.031,21.102c-0.589-0.589-0.589-1.543,0-2.132l1.403-1.403 c0.589-0.589,1.543-0.589,2.132,0l12.868,12.868c0.589,0.589,0.589,1.543,0,2.132l-1.403,1.403 C28.442,34.558,27.487,34.558,26.898,33.969z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Connected);
export default __webpack_public_path__ + "static/media/icons8-connected.cdfcb3e09e8bf0cef0a4705a0dee7b9c.svg";
export { ForwardRef as ReactComponent };